import React from 'react';
// @ts-ignore
import {DateTime} from "luxon";

export const getFormattedYear = () => {
    return DateTime.now().toFormat('yyyy');
};
